import { EventBus } from "./event-bus";

export async function withLoadingScreen(fn, message) {
    EventBus.$emit("globalLoadScreen", { status: true, message: message });
    return fn()
        .then((result) => {
            EventBus.$emit("globalLoadScreen", { status: false, message: "" });
            return result;
        })
        .catch((error) => {
            EventBus.$emit("globalLoadScreen", { status: false, message: "" });
            throw error;
        });
}
